module.exports = __webpack_public_path__ + "static/media/1016268.28bb0207.png";